import { render, staticRenderFns } from "./Apk.vue?vue&type=template&id=32e83876&"
import script from "./Apk.vue?vue&type=script&lang=js&"
export * from "./Apk.vue?vue&type=script&lang=js&"
import style0 from "./Apk.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../frontend-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports